import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { displaySnackBar } from '../../common/displaySnackbar';
import { SET_ROLES } from '../../graphql/role/mutation';
import { SetRoles, SetRolesVariables } from '../../graphql/role/types/SetRoles';

export const useSetRoles = () => {
  const client = useApolloClient();
  return useMutation<SetRoles, SetRolesVariables>(SET_ROLES, {
    onCompleted: (data) => {
      if (data?.setRoles)
        displaySnackBar(client, {
          type: 'SUCCESS',
          message: 'Mise à jour effectuée avec succès',
          isOpen: true,
        });
    },
  });
};
